export function generatePassword(length = 12) {
    const charset = {
      upper: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      lower: "abcdefghijklmnopqrstuvwxyz",
      digits: "0123456789",
      special: "!@#$%^&*()_+[]{}|;:,.<>?/",
    };
  
    let password = "";
    
    // Ensure the password contains at least one character from each group
    password += charset.upper.charAt(Math.floor(Math.random() * charset.upper.length));
    password += charset.lower.charAt(Math.floor(Math.random() * charset.lower.length));
    password += charset.digits.charAt(Math.floor(Math.random() * charset.digits.length));
    password += charset.special.charAt(Math.floor(Math.random() * charset.special.length));
    
    // Add random characters to reach the desired length
    const allCharacters = charset.upper + charset.lower + charset.digits + charset.special;
    for (let i = password.length; i < length; i++) {
      password += allCharacters.charAt(Math.floor(Math.random() * allCharacters.length));
    }
    
    // Shuffle the password to ensure randomness
    password = password.split('').sort(() => 0.5 - Math.random()).join('');
    
    return password;
  }